import { useSnackbar } from "notistack";
import { web_url } from "../../config/config";

const SharePostPopup = ({ postData }) => {
  const { enqueueSnackbar } = useSnackbar();

  const prepareShareContent = (postData) => {
    let shareContent = `*TalentSource*\n*Connecting Top Talent With Top Jobs.*\n\n`;
    if (postData?.description) {
      shareContent += `${postData.description}\n\n`;
    }
    shareContent += `Explore more career opportunities:\n${web_url}`;
    return shareContent;
  };

  const shareToWhatsApp = () => {
    const shareText = prepareShareContent(postData);
    const url = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
    window.open(url, "_blank");
  };

  const shareToFacebook = () => {
    const url = encodeURIComponent(web_url);
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(facebookShareUrl, "_blank");
  };

  const shareToTwitter = () => {
    const shareText = prepareShareContent(postData);
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      shareText
    )}`;
    window.open(url, "_blank");
  };

  const shareToLinkedIn = () => {
    let shareContent = `TalentSource\nConnecting Top Talent With Top Jobs.\n\n`;
    if (postData?.description) {
      shareContent += `${postData.description}\n\n`;
    }
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      `${web_url}`
    )}&text=${encodeURIComponent(shareContent)}`;
    window.open(url, "_blank");
  };

  const shareToEmail = () => {
    const subject = "Check out this post!";
    const body = prepareShareContent(postData);
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(gmailLink, "_blank");
  };

  const shareToOutlook = () => {
    const subject = "Check out this post!";
    const body = prepareShareContent(postData);
    const outlookLink = `https://outlook.live.com/owa/?path=/mail/action/compose&subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(outlookLink, "_blank");
  };

  const copyToClipboard = async () => {
    try {
      const shareText = prepareShareContent(postData);
      await navigator.clipboard.writeText(shareText);
      enqueueSnackbar("Content copied to clipboard!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to copy please try again", { variant: "error" });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="card border-0">
              <div className="card-body">
                <div className="row justify-content-center gy-3 gx-2">
                  {[
                    {
                      icon: "fab fa-whatsapp",
                      title: "WhatsApp",
                      onClick: shareToWhatsApp,
                      color: "#25D366",
                    },
                    {
                      icon: "fab fa-facebook-f",
                      title: "Facebook",
                      onClick: shareToFacebook,
                      color: "#1877F2",
                    },
                    {
                      icon: "fab fa-x-twitter",
                      title: "X",
                      onClick: shareToTwitter,
                      color: "#000000",
                    },

                    {
                      icon: "fab fa-linkedin-in",
                      title: "LinkedIn",
                      onClick: shareToLinkedIn,
                      color: "#0077B5",
                    },
                    {
                      icon: "fas fa-envelope",
                      title: "Email",
                      onClick: shareToEmail,
                      color: "#EA4335",
                    },
                    {
                      icon: "fas fa-envelope-open-text",
                      title: "Outlook",
                      onClick: shareToOutlook,
                      color: "#0072C6",
                    },
                    {
                      icon: "fas fa-copy",
                      title: "Copy Text",
                      onClick: copyToClipboard,
                      color: "#6c757d",
                    },
                  ].map((item, index) => (
                    <div
                      className="col-4 col-md-3 d-flex justify-content-center"
                      key={index}
                    >
                      <button
                        type="button"
                        onClick={item.onClick}
                        className="share-icon-btn"
                        style={{ backgroundColor: item.color }}
                        title={item.title}
                      >
                        <i className={item.icon}></i>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SharePostPopup;
